/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Ledger_CurrentInputs */

const vi_customer_debt_ledger_current = /** @type {(inputs: Customer_Debt_Ledger_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dư nợ hiện tại`)
};

/**

* @param {Customer_Debt_Ledger_CurrentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_ledger_current = /** @type {((inputs?: Customer_Debt_Ledger_CurrentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Ledger_CurrentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_ledger_current(inputs)
});